import { createContext } from 'react';

interface NavigationMenuContextType {
  variant: 'side' | 'mobile';
  expanded: boolean;
}

export const NavigationMenuContext = createContext<NavigationMenuContextType>({} as NavigationMenuContextType);
